import React from 'react';
import { SignupForm } from '../components/auth/SignupForm';
import { useLocation } from 'wouter';
import { SEO } from '../components/SEO';

export function SignupPage() {
  const [, setLocation] = useLocation();

  const handleSignupSuccess = () => {
    setLocation('/');
  };

  return (
    <>
      <SEO
        title="Sign Up | btoolme"
        description="Create your btoolme account to get personalized business software recommendations."
        path="/signup"
        noindex={true}
      />
      <SignupForm onSuccess={handleSignupSuccess} />
    </>
  );
}